import React from 'react';
import style from './style.scss';

const Spinner = props =>
  <div {...props} className={[style.spinner, props.className].join(' ')}>
    <div className={style.rect1} />
    <div className={style.rect2} />
    <div className={style.rect3} />
    <div className={style.rect4} />
    <div className={style.rect5} />
  </div>;

export default Spinner;



// WEBPACK FOOTER //
// ./app/components/Spinner/index.js